import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SiteWorkOrdersService } from 'app/_services/site-work-orders.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'edit-min-party-modal',
  templateUrl: './edit-min-party-modal.component.html',
})
export class EditMinPartyModalComponent implements OnInit {
  @Input() workOrder: any;

  public form: FormGroup;

  constructor(
    private activeModal: NgbActiveModal,
    private workOrderService: SiteWorkOrdersService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      minPartySize: new FormControl(this.workOrder.minimumPartySize, [Validators.required, Validators.min(1),Validators.max(30)]),
    });
  }

  public closeModal() {
    this.activeModal.dismiss();
  }


  public onSubmit() {
    const values = this.form.value;

    const body = {

      minimumPartySize : values.minPartySize,
      // required for the PUT Request:
      id: this.workOrder.id,
      released: this.workOrder.released,
      approvalStatus: this.workOrder.approvalStatus,
      description: this.workOrder.description,
      checkOnSiteFormId: this.workOrder.checkOnSiteFormId,
      checkOffSiteFormId: this.workOrder.checkOffSiteFormId,
      scheduledStartTime: this.workOrder.scheduledStartTime,
      scheduledEndTime: this.workOrder.scheduledEndTime,
      exemptFromAssetScheduling: this.workOrder.exemptFromAssetScheduling,
    };

    this.workOrderService.updateWorkOrder(body).subscribe(() => {
      Swal.fire('Updated!', 'Work Order has been updated.', 'success');
      this.activeModal.close('refresh');
    });
  }
}
